import CountryPageRenderer from '../components/CountryPageRenderer';
import croatiaData from '../data/country-pages/croatia';

export default function CroatiaCountryPage() {
  return <CountryPageRenderer data={croatiaData} />;
}
